import 'core-js/stable'

import Vue from 'vue'
import store from '~/store'
import App from '~/components/App'
import VueScrollTo from 'vue-scrollto'
import * as Sentry from '@sentry/browser'

if (process.env.MIX_SENTRY_DSN && process.env.MIX_SENTRY_DSN.length) {
	Sentry.init({
		dsn: process.env.MIX_SENTRY_DSN,
		integrations: [new Sentry.Integrations.Vue({ Vue })]
	})
}

Vue.use(VueScrollTo)

import '~/plugins'
// import '~/components'

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.config.performance = false

new Vue({
	store,
	...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/frontend-vue/frontend.js